/** Scale 1080×1920 Figma artboard px → viewport units */
export { pixelsToVW as pxW, pixelsToVH as pxH } from '../EntryPage/EntryPage';

export const ARTBOARD_W = 1080;
export const ARTBOARD_H = 1920;

/** Portrait UI: scale heights from artboard width so type & controls stay proportional */
export function pxArt(pixels, designWidth = ARTBOARD_W) {
  return `${(pixels / designWidth) * 100}vw`;
}

/** Responsive scale that never exceeds design px (stops oversizing on wide screens) */
export function clampVwMax(pixels, designWidth = ARTBOARD_W) {
  return `min(${(pixels / designWidth) * 100}vw, ${pixels}px)`;
}
